import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Search, Filter, Mail, CreditCard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export const DashboardToolbar = ({ count, query, setQuery, sevFilter, setSevFilter }) => {
  const navigate = useNavigate();
  const [digesting, setDigesting] = useState(false);

  const sendDigest = async () => {
    setDigesting(true);
    try {
      const { data } = await api.post("/digest/run");
      toast.success(data.message);
    } catch {
      toast.error("Could not send digest");
    } finally {
      setDigesting(false);
    }
  };

  return (
    <div className="p-4 border-b border-border space-y-3">
      <div className="flex items-baseline justify-between">
        <h2 className="font-heading text-xl font-black tracking-tighter">Incidents</h2>
        <span className="font-mono text-xs text-muted-foreground" data-testid="incident-count">{count} total</span>
      </div>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" onClick={sendDigest} disabled={digesting} data-testid="send-digest-btn"
          className="flex-1 rounded-sm border-border gap-2 text-xs"><Mail className="w-3.5 h-3.5" /> {digesting ? "Sending…" : "Weekly Digest"}</Button>
        <Button variant="outline" size="sm" onClick={() => navigate("/credits")} data-testid="buy-credits-link"
          className="flex-1 rounded-sm gap-2 text-xs border-[#007AFF]/50 text-[#007AFF] hover:bg-[#007AFF]/10 hover:text-[#007AFF]">
          <CreditCard className="w-3.5 h-3.5" /> Buy Credits</Button>
      </div>
      <div className="relative">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input value={query} onChange={(e) => setQuery(e.target.value)} data-testid="incident-search"
          placeholder="Search reports…" className="pl-9 bg-[#0A0A0A] border-border rounded-sm focus-visible:ring-[#007AFF]" />
      </div>
      <Select value={sevFilter} onValueChange={setSevFilter}>
        <SelectTrigger data-testid="severity-filter" className="bg-[#0A0A0A] border-border rounded-sm text-sm">
          <div className="flex items-center gap-2"><Filter className="w-3.5 h-3.5" /><SelectValue /></div>
        </SelectTrigger>
        <SelectContent className="bg-[#0A0A0A] border-border rounded-sm">
          <SelectItem value="all">All severities</SelectItem>
          <SelectItem value="Critical">Critical</SelectItem>
          <SelectItem value="High">High</SelectItem>
          <SelectItem value="Medium">Medium</SelectItem>
          <SelectItem value="Low">Low</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
